import React from "react";

const OttServices = () => {
  return (
    <div className=" p-6">
      <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
        <div className="flex justify-center lg:w-1/2 ">
          <img
            src="\assets\images\homeImages\ott-platform.webp"
            alt="OTT Platform"
            className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
          />
        </div>

        <div className="lg:w-1/2 lg:text-left p-4">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
          video streaming ott platform development service provider
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
           In today’s digital era, your content succeeds only when it reaches your audience without interruptions, in high quality, and with intelligent features. At Ayanshtech Solutions, we are a leading Video Streaming <br /> <a  className="  relative   
  before:content-[''] before:absolute before:left-1/2 before:-bottom-1 
  before:h-[2px] before:w-0 before:bg-green-600 
  before:transition-all before:duration-300 
  hover:before:left-0 hover:before:w-full text-green-600 font-bold" href="https://ayanshtechnology.com/streaming-platform"> OTT Platform Development Service Provider </a>, helping businesses build modern, secure, and fully scalable OTT platforms.
We create custom OTT solutions that deliver a seamless streaming experience similar to top platforms like Netflix, Amazon Prime, and Hotstar. Our advanced technology elevates your brand to the next level and provides your viewers with a truly premium watching experience.
          </p>
          <a href="/streaming-platform">
            <button className="bg-gradient-to-r from-blue-600 to-green-500 text-white px-6 py-3 rounded-full group hover:from-blue-900 hover:to-blue-600">
              View More
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default OttServices;
